// src/features/offers/offersApi.ts

import { createGenericApiSlice } from "../../../Api/Factory/genericApiFactory";
import { TagTypes } from "../../../Api/Types/tagTypes";
import { Offer } from "../Types/offerTypes";

const baseOffersApi = createGenericApiSlice<Offer>({
	reducerPath: "offersApi",
	tag: TagTypes.Offer,
	endpoint: "offers",
});

export const offersApi = baseOffersApi.enhanceEndpoints({
	addTagTypes: [TagTypes.OfferImages],
});

export const {
	useGetAllQuery: useGetOffersQuery,
	useGetByIdQuery: useGetOfferByIdQuery,
	useCreateMutation: useCreateOfferMutation,
	useUpdateMutation: useUpdateOfferMutation,
	useDeleteMutation: useDeleteOfferMutation,
} = offersApi;
